'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transformProfile = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxSimpleAuth = require('redux-simple-auth');

var transformProfile = exports.transformProfile = function transformProfile(_ref) {
	var account = _ref.account,
	    profile = _ref.profile;

	return account.account_type === 'patient' ? {
		patient: {
			firstname: profile.firstname,
			lastname: profile.lastname,
			email: account.name,
			birthdate: profile && profile.attributes && profile.attributes.birthdate,
			gender: profile && profile.attributes && profile.attributes.gender
		}
	} : {
		specialist: {
			account: _extends({}, account),
			profile: _extends({}, profile)
		}
	};
};

var INITIAL_STATE = {};

var accountProfileData = function accountProfileData(state, action) {
	switch (action.type) {
		case _reduxSimpleAuth.actionTypes.RESTORE:
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_SUCCEEDED:
			{
				return Object.assign({}, state, transformProfile({
					account: action.payload.account,
					profile: action.payload.selectedProfile
				}), {
					login: _extends({}, state.login, {
						error: false,
						submitAttempted: true,
						submitFailed: false
					})
				});
			}
		case _reduxSimpleAuth.actionTypes.INVALIDATE_SESSION:
			return INITIAL_STATE;
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = accountProfileData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/account-profile-data.js
// module id = 1692
// module chunks = 0